import { Reveal, Eyebrow } from "@/components/Reveal";

export default function Vision() {
  return (
    <section id="vision" className="relative overflow-hidden px-6 py-28 sm:px-12 sm:py-40 lg:px-20" data-testid="vision-section">
      <p
        aria-hidden="true"
        className="font-code absolute right-4 top-1/2 hidden -translate-y-1/2 text-[10px] uppercase tracking-[0.5em] text-[#8C857B] [writing-mode:vertical-rl] lg:block"
      >
        SANZONE Atelier — The First Wolf — Instinct. Refined.
      </p>
      <div className="mx-auto max-w-7xl">
        <div className="flex items-end justify-between gap-8">
          <Reveal>
            <Eyebrow>[ 01 — The Vision ]</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-code hidden text-[10px] uppercase tracking-[0.35em] text-[#8C857B] sm:block">
              Manifesto / T. Sanzone
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <p
            className="mt-14 max-w-5xl font-display text-3xl leading-[1.15] tracking-tight text-[#221812] sm:text-5xl sm:leading-[1.08] lg:text-6xl"
            data-testid="vision-statement"
          >
            <span className="align-top text-[0.6em] italic text-[#9A7B3F]">“</span>
            SANZONE is wearable art for the <span className="italic">bold</span> and <span className="italic">fearless</span> — original street apparel and custom couture by{" "}
            <span className="italic text-[#5E1A22]">Toriano Sanzone</span>.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 md:grid-cols-12">
          <Reveal delay={0.25} className="md:col-span-4 md:col-start-5">
            <p className="text-sm leading-relaxed text-[#55504A] sm:text-base">
              Nothing here is for sale yet. The first public collection opens April 2027 — until then, the pack gathers.
            </p>
          </Reveal>
          <Reveal delay={0.35} className="md:col-span-3 md:col-start-10">
            <div className="border-l border-[#9A7B3F]/50 pl-6">
              <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#9A7B3F]">Est. Chicago</p>
              <p className="mt-3 text-xs leading-relaxed text-[#8C857B]">
                One designer. One-of-one works. No mass production, no repetition.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
